import * as React from 'react';
import { Text } from '../Text';
import { CALENDAR_DATA_KEYS } from './dataHooks';
import { st, classes } from './CalendarCell.st.css';
import {
  CalendarCellAlignment,
  CalendarCellDefaultProps,
  CalendarCellProps,
  CalendarCellTimes,
} from './types';

/** CalendarCell */
export class CalendarCell extends React.Component<CalendarCellProps> {
  static displayName = 'CalendarCell';
  static defaultProps: CalendarCellDefaultProps = {
    stretchable: false,
    current: false,
    alignment: CalendarCellAlignment.left,
    timeType: CalendarCellTimes.futureDate,
  };

  getDataAttributes() {
    const { stretchable, current, timeType, alignment } = this.props;

    return {
      [CALENDAR_DATA_KEYS.Stertchable]: stretchable,
      [CALENDAR_DATA_KEYS.TimeType]: timeType,
      [CALENDAR_DATA_KEYS.Current]: current,
      [CALENDAR_DATA_KEYS.Alignment]: alignment,
    };
  }

  render() {
    const {
      title,
      children,
      stretchable,
      current,
      alignment,
      timeType,
      className,
    } = this.props;

    return (
      <div
        {...this.getDataAttributes()}
        data-hook={this.props['data-hook']}
        className={st(
          classes.root,
          { stretchable, current, alignment, timeType },
          className,
        )}
      >
        <div className={classes.innerContainer}>
          <Text className={classes.title}>{title}</Text>
          {children}
        </div>
      </div>
    );
  }
}
